/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed, Jul 21st 2021, 9:17:12 pm
 *
 * *****************************************************
 */

import { TextStyle } from '@shopify/polaris';

import Spinner from 'features/common/views/components/Spinner';

import { Container } from './styles';

/**
 * Loading content for verifying code
 */
const TokenVerifyLoading = () => {
  return (
    <Container>
      <Spinner />
      <TextStyle>Checking...</TextStyle>
    </Container>
  );
};

export default TokenVerifyLoading;
